export default "__VITE_ASSET__BzkQ0Iog__"